import { render } from "./ConfirmItem.vue?vue&type=template&id=0bc245f3&scoped=true"
import script from "./ConfirmItem.vue?vue&type=script&lang=js"
export * from "./ConfirmItem.vue?vue&type=script&lang=js"

import "./ConfirmItem.vue?vue&type=style&index=0&id=0bc245f3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bc245f3"]])

export default __exports__